// extracted by mini-css-extract-plugin
export default {"root":"_2rQGd","small":"_1_ir5","normal":"FGZRt"};